import { format, isValid, parseISO } from 'date-fns';

export default function getDateAndTimeFromIsoDate(dateString) {
  const date = parseISO(dateString);
  if (isValid(date)) {
    return format(date, 'dd.MM.yyyy HH:mm');
  }
  return '-';
}
